import classNames from "classnames"
import React from "react"

import TextButton from "@components/elements/V2/Buttons/TextButton"
import GatsbyStoryblokImage from "@components/elements/V2/GatsbyStoryblokImage"
import ArrowIcon from "@components/elements/V2/Icons/ArrowIcon"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"

export type EcoSystemIntroCardContentProps = {
  size: "large" | "medium" | "small"
  iconUrl?: string
  iconAlt?: string
  titleText: string
  descriptionText: string
  textColor: Color
  buttonText?: string
  isClickable: boolean
}

const EcoSystemIntroCardContent = ({
  size,
  iconUrl,
  iconAlt,
  titleText,
  descriptionText,
  textColor,
  buttonText,
  isClickable,
}: EcoSystemIntroCardContentProps) => {
  const isLarge = size === "large"

  return (
    <div
      className={classNames(
        "flex",
        isLarge
          ? "h-full flex-1 flex-col justify-between"
          : "flex-row items-start gap-16 sm:flex-col md:flex-row"
      )}
    >
      {iconUrl && (
        <div
          className={classNames(
            "size-40 shrink-0 overflow-hidden rounded-full lg:size-[50px]",
            !isLarge && "lg:size-40"
          )}
        >
          <GatsbyStoryblokImage
            image={iconUrl}
            alt={iconAlt || ""}
            width={50}
            height={50}
            className="h-full w-full object-contain"
          />
        </div>
      )}

      <div className={classNames(isLarge ? "space-y-16" : "space-y-8")}>
        <div className="space-y-8">
          <Typography
            weight="medium"
            size={isLarge ? "lead-md" : "body-lg"}
            font="grotesk"
            color={textColor}
            text={titleText}
            leadingNone={!isLarge}
          />
          <Typography
            weight="book"
            size={isLarge ? "body-md" : "body-sm"}
            font="grotesk"
            color={textColor}
            text={descriptionText}
          />
        </div>

        {isLarge && buttonText && isClickable && (
          <TextButton
            color={textColor}
            text={buttonText}
            style="icon"
            icon={<ArrowIcon />}
            className="pointer-events-none"
          />
        )}
      </div>
    </div>
  )
}

export default EcoSystemIntroCardContent
